import { SAVED_POSITION_STORAGE_KEY } from '~/core/constants/sessionStorage'

export default function(_, __, savedPosition) {
  sessionStorage.setItem(SAVED_POSITION_STORAGE_KEY, savedPosition?.y || '')
}
